{
  "version": "1.0",
  "description": "User prompt templates for report element generation",
  "templates": [
    {
      "elementType": "table",
      "template": "Create a table using dataset {dataset_name}. Show columns {columns}. Apply filter {filter_conditions}. Sort by {sort_column} {sort_order}. Show top {top_n} records.",
      "example": "Create a table using dataset App_Demographics. Show columns Application_ID, Application_Name, Lifecycle_Status. Apply filter Lifecycle_Status = Production. Sort by Application_Name ascending. Show top 10 records."
    },
    {
      "elementType": "card",
      "template": "Create a card showing {aggregation} of {measure_column} from dataset {dataset_name}. Apply filter {filter_conditions}.",
      "example": "Create a card showing count of Application_ID from App_Demographics where Lifecycle_Status = Production."
    },
    {
      "elementType": "stat_card",
      "template": "Create a stat card showing {kpi_description} from dataset {dataset_name}. Apply filter {filter_conditions}.",
      "example": "Create a stat card showing total active applications from App_Demographics where Lifecycle_Status = Production."
    },
    {
      "elementType": "bar_chart",
      "template": "Create a bar chart using dataset {dataset_name}. Group by {dimension}. Show {aggregation} of {measure}. Apply filter {filter_conditions}.",
      "example": "Create a bar chart using App_Demographics. Group by Technical_Owner. Show count of Application_ID. Apply filter Lifecycle_Status = Production."
    },
    {
      "elementType": "column_chart",
      "template": "Create a column chart using dataset {dataset_name}. Group by {dimension}. Show {aggregation} of {measure}. Apply filter {filter_conditions}.",
      "example": "Create a column chart using App_Demographics. Group by Service_Level_Owner. Show count of Application_ID. Apply filter Lifecycle_Status = Production."
    },
    {
      "elementType": "donut_chart",
      "template": "Create a donut chart using dataset {dataset_name}. Use {category_column} as category. Show {aggregation} of {measure_column}. Apply filter {filter_conditions}.",
      "example": "Create a donut chart using App_Demographics. Use Lifecycle_Status as category. Show count of Application_ID."
    },
    {
      "elementType": "line_chart",
      "template": "Create a line chart using dataset {dataset_name}. Use {date_column} on X-axis and {aggregation} of {measure_column} on Y-axis. Apply filter {filter_conditions}.",
      "example": "Create a line chart using App_Trend. Use Created_Date on X-axis and count of Application_ID on Y-axis."
    },
    {
      "elementType": "stack_chart",
      "template": "Create a stacked chart using dataset {dataset_name}. Group by {dimension}. Use {series_column} as stack. Show {aggregation} of {measure}. Apply filter {filter_conditions}.",
      "example": "Create a stacked chart using App_Demographics. Group by Technical_Owner. Use Lifecycle_Status as stack. Show count of Application_ID."
    },
    {
      "elementType": "speedometer",
      "template": "Create a speedometer showing actual value {actual_measure} compared against target value {target_measure} from dataset {dataset_name}.",
      "example": "Create a speedometer showing current application onboarding count compared against annual target."
    },
    {
      "elementType": "metrics",
      "template": "Create a metrics report using dataset {dataset_name}. Group by {group_columns}. Calculate metrics {metric_list}. Apply filter {filter_conditions}.",
      "example": "Create a metrics report using App_Demographics. Group by Technical_Owner. Calculate Total Applications, Production Applications, Retired Applications."
    },
    {
      "elementType": "drill_down_matrix",
      "template": "Create a drill down matrix using dataset {dataset_name}. Hierarchy levels are {level1}, {level2}, {level3}. Include measures {measures}. Apply filter {filter_conditions}.",
      "example": "Create a drill down matrix using App_Demographics. Hierarchy levels are CIO, Technical_Owner, Service_Level_Owner. Include count of Application_ID."
    },
    {
      "elementType": "filter",
      "template": "Create a filter using dataset {dataset_name}. Allow filtering by columns {filter_columns}.",
      "example": "Create a filter using App_Demographics. Allow filtering by Lifecycle_Status, Technical_Owner and Service_Level_Owner."
    }
  ]
}